import { ActionCatalogLoadSuccess } from "@store/catalog";
import { AngularFirestore } from "@angular/fire/firestore";
import { AppState } from "@store/state";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";

@Injectable({ providedIn: "root" })
export class FirebaseWriteService {
  constructor(private afs: AngularFirestore, private store: Store<AppState>) {}

  /**
   * store the order in firebase db
   * @param order 
   */
  createOrder(order) {
    const ordersDb = this.afs.doc<any>(
      "stores/" + order.s + "/" + "orders/" + order.id
    );

    ordersDb.set(order);
  }

  /**
   * store the quote in firebase db
   * @param cartquote
   */
  voidQuote(cartquote) {
    const cartquoteDB = this.afs.doc<any>(
      "stores/" + cartquote.s + "/" + "quotes/" + Date.now()
    );
    cartquoteDB.set(cartquote);
  }
}
